'use client';

import { Button } from '@nf/ui';
import { CoinsIcon, DepositIcon, GameOverIcon, ToolIcon, WalletIcon } from '@/components/icons/svg-icons';
import { useTranslations } from 'next-intl';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { miniStreamingStyle } from '@/features/odds-table-mars/components/mini-streaming/mini-streaming.style';
import { useAccountInfo } from '@/hooks/query/account';
import { Styles } from './streaming-unactived.style';
import { cx } from 'styled-system/css';

export const StreamingUnactivated = ({ type }: { type: string }) => {
	const { user } = useAccountInfo();
	const t = useTranslations('General');
	const view = useAppearanceStore(state => state.view);

	let content;

	if (view === ViewEnum.mars && type === '1') {
		let lang;

		switch (user?.Lang.toLowerCase()) {
			case 'zh-tw':
				lang = 'ch';
				break;
			case 'zh-cn':
			case 'zh-hans':
				lang = 'cs';
				break;
			case 'th-th':
				lang = 'th';
				break;
			case 'vi-vn':
				lang = 'vn';
				break;
			case 'id-id':
				lang = 'id';
				break;
			case 'ko-kr':
				lang = 'ko';
				break;
			case 'ja-jp':
				lang = 'jp';
			default:
				lang = 'en';
				break;
		}

		return (
			<div className={miniStreamingStyle.view}>
				{/* 錯誤背景圖現有的語系：en / ch / cs / id / jp / ko / th / vn */}
				<video poster={`/images/common/streaming_error_${lang}.jpg`} />
			</div>
		);
	}

	switch (type) {
		case '1':   // Maintain
			content =
				<>
					<GameOverIcon />
					<div className="video-msg">{t('lbl_StreamingError')}<br />{t('lbl_StreamingError01')}</div>
				</>
			break;
		case '2':   // Api user show icon
			content =
				<>
					<WalletIcon />
					<div className="video-msg">{t('lbl_StreamingDepositToView')}</div>
				</>
			break;
		case '3':   // Athena user show icon
			content =
				<>
					<div className="video-msg">{t('lbl_StreamingDepositToView')}</div>
					<Button className="btn--primary btn--capsule">
						<DepositIcon />
						<span className="btn__text">{t('lbl_OKDepositNow')}</span>
					</Button>
				</>
			break;
		case '4':   // MiniumBet
			content =
				<>
					<CoinsIcon />
					<div className="video-msg">{t('lbl_StreamingBetToView')}</div>
				</>
			break;
		case '5':   // Gameover
			content =
				<>
					<GameOverIcon />
					<div className="video-msg">{t('lbl_matchended')}</div>
				</>
			break;
		case '6':   // Fixing
			content =
				<div className={Styles.streamingUnactivedFixing}>
					<ToolIcon />
					<div className="video-msg">{t('lbl_StrmUMMsg')}</div>
				</div>
			break;
	}

	return (
		<div className={cx('video-unactivated', Styles.streamingUnactived)}>
			<div className="video-content">
				{content}
			</div>
		</div>
	);
};
